<div fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="column" fxFlex="100" class="container extra-mile" fxLayoutGap="48px">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutGap="20px">
        <h2>Going the extra mile to help find your items a new home</h2>
        <p>
          While our charity partners strive to accept everything, some items may not be the right fit for their mission. In such cases, we
          encourage our haulers to go the extra mile to find a new home for those items, even if it means taking stops at additional
          charities or ethically disposing or recycling your items.
        </p>
      </div>
      <img src="/assets/split-screen-v3/extra-mile.png" />
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
      <button fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="primary" (click)="goToPrimary(sectionType)">
        <span fxFlex="100">Continue to donation{{ !isSmallWindowSize ? ' pickup' : '' }}</span>
        <mat-icon svgIcon="ss3-arrow-right" />
      </button>
    </div>
  </div>
</div>
